import { Swiper as Sp, SwiperSlide } from "swiper/react"
import { Container, Row } from "react-bootstrap"
import SwiperCore, { Autoplay } from "swiper"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/autoplay"

const PhoneSwiper: React.FC<{ title?: string }> = ({
  title = "Comparamos entre más de 50 Compañías Eléctricas",
}) => {
  SwiperCore.use([Autoplay])

  return (
    <Container fluid>
      <Row>
        <h2
          style={{
            textAlign: "center",
            color: "var(--fiva-color)",
            fontSize: "1.2rem",
          }}
        >
          {title}
        </h2>
        <Sp
          breakpoints={{
            0: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={20}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          loop={true}

        >
          {[
            "/Images/landing/swiper-logos/Logo_Audax.png",
            // "/Images/landing/swiper-logos/Repsol-logo-logotype.png",
            "/Images/landing/swiper-logos/syder_logo.png",
            "/Images/landing/swiper-logos/eleia-logo.png",
            "/Images/landing/swiper-logos/logo-visalia.png",
            "/Images/landing/swiper-logos/gana-energia-logo.png",
          ].map((image, index) => (
            <SwiperSlide
              key={index}
              style={{
                minHeight: "14vh",
                backgroundImage: `url(${image})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }}
            />
          ))}
        </Sp>
        <Sp
          breakpoints={{
            0: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={20}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            reverseDirection: true,
          }}
          modules={[Autoplay]}
          loop={true}

        >
          {[
            "/Images/landing/swiper-logos/Endesa-Logo-2048x1152.png",
            "/Images/landing/swiper-logos/Plenitude-Logo.png",
            "/Images/landing/swiper-logos/Naturgy-ok.png",
            "/Images/landing/swiper-logos/total_logo.png",
            "/Images/landing/swiper-logos/412562538-axpo.png",
            "/Images/landing/swiper-logos/Iberdrola_logo_new.png",
          ].map((image, index) => (
            <SwiperSlide
              key={index}
              style={{
                minHeight: "10vh",
                backgroundImage: `url(${image})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }}
            />
          ))}
        </Sp>
      </Row>
    </Container>
  )
}

export default PhoneSwiper
